import { t } from '@lingui/core/macro';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SidebarMenuItem } from 'app/domains/common-ui';
import { useGtm } from 'shared/domains/tracking';
const UG_ID = Number(process.env.USER_GUIDING_RESOURCE_CENTER_ID);
export function UserGuidingButton() {
    const { push } = useGtm();
    const handleClick = () => {
        if (process.env.NODE_ENV === 'production') {
            push({ event: 'open_user_guiding_resource_center' });
        }
        try {
            window.userGuiding.launchResourceCenter(UG_ID, { sidebarOpen: true });
        }
        catch (_a) {
            window.open('https://knowledgehub.pocketlaw.com/', '_blank');
        }
    };
    return (<SidebarMenuItem icon={<Falcon icon="lightbulb"/>} label={t({ comment: 'User guiding knowledge hub menu label', message: 'Knowledge hub', context: 'sidebar' })} onClick={handleClick}/>);
}
